import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../images/ais-cut-logo.png';
import '../css/Footer.css';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
  logo: {
    width: '30%',
  },
});

/**
 * A logo component for AIS logo
 * @component Logo
 * @return {Component} Logo component
 */
function HeadLogo() {
  const classes = useStyles();

  return <img src={Logo} alt="logo" className={classes.logo} />;
}

/**
 * The footer component with dropdown menus and main logo
 * @component Footer
 * @return {Component} Footer component
 */
export default function Footer() {
  return (
    <footer className="f-site-footer">
      <div className="f-container">
        <div className="f-child">
          <h6>Quick Links</h6>
          <ul className="f-footer-links">
            <li>
              <a href="/client-login">Client Portal</a>
            </li>
            <li>
              <a href="/careers">Careers</a>
            </li>
            <li>
              <a href="/employee-login">Employees</a>
            </li>
            <li>
              <a href="/encyclopedia">Encyclopedia</a>
            </li>
            <li>
              <a href="/coronavirus">COVID-19 Response</a>
            </li>
            <li>
              <a href="/https://www.aps.org/">APS Physics</a>
            </li>
            <li>
              <a href="http://www.usa.gov">USA.gov</a>
            </li>
          </ul>
        </div>
        <div className="f-child">
          <h6>Information</h6>
          <ul className="f-footer-links">
            <li>
              <a href="/ceo">Office of the CEO</a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.aisincorporated.blogspot.com"
              >
                Blog: Inside AIS
              </a>
            </li>
            <li>
              <a href="/support">Client Services Center</a>
            </li>
            <li>
              <a href="/research">Physics Research</a>
            </li>
            <li>
              <a href="/ethics">Ethics</a>
            </li>
            <li>
              <a href="/newsroom">Newsroom</a>
            </li>
            <li>
              <a href="/sitemap">Sitemap</a>
            </li>
          </ul>
        </div>
        <div className="f-child">
          <h6>Legal</h6>
          <ul className="f-footer-links">
            {/* <li>
              <a href="/legal">EULA</a>
            </li> */}
            <li>
              <a href="/privacypolicy">Privacy Policy</a>
            </li>
            <li>
              <a href="/termsofuse">Terms Of Use</a>
            </li>
            {/* <li>
              <a href="/cookiepolicy">Cookie Policy</a>
            </li> */}
          </ul>
        </div>
        <div className="f-vertical" />
        <div className="right-block">
          <HeadLogo />
          <p style={{maxWidth: '40%'}}>DUNS ID#: 786529524</p>
          <ul className="f-social-icons">
            <li>
              <a
                className="facebook"
                href="https://www.facebook.com/aisincorporated/"
              >
                <i className="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a
                className="twitter"
                href="https://twitter.com/aisincorporated/"
              >
                <i className="fa fa-twitter"></i>
              </a>
            </li>
            <li>
              <a
                className="linkedin"
                href="https://www.linkedin.com/company/aisincorporated/"
              >
                <i className="fa fa-linkedin"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <p className="f-copyright-text">
        &copy;
        <a href="/about"> Advanced Intelligence Services Corp.</a>
        &nbsp; All rights reserved.
      </p>
    </footer>
  );
}

Footer.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};
